import { useContext, useEffect } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";
import { Image } from "../../Image/Image";
import LoadingMore from "../Loading/LoadingMore";
import DetailHeader from "./DetailHeader";
import DetailBody from "./DetailBody";

const navigate = (url) => {
	if (window && window.location && window.location.pathname && window.location.pathname !== url) {
		window.history.pushState({}, '', url);
	}
};

const SportsCampsDetail = () => {
	const { isLoadingMore, setMoreInfoVisible, moreInfoCard } =
		useContext(SportsCampsContext);

	var url = window.location.protocol + "//" + window.location.host + window.location.pathname;

	const setIdUrl = () => {
		const id = moreInfoCard.activityId;
		navigate(url + "camp/" + id)
	};

	useEffect(() => {
		if (!url.includes("camp")) {
			setIdUrl();
		}
	}, []);

	//Remopve query param from url
	const deleteIdUrl = () => {
		if (url.includes("camp")) {
			const newUrl = url.split("camp");
			navigate(newUrl[0]);
		}
		else {
			navigate(url);
		}
	}

	const hideSportsCampDetail = () => {
		setMoreInfoVisible((prevMoreInfoVisible) => !prevMoreInfoVisible);
		deleteIdUrl();
	};

	const stopPropagation = (e) => {
		e.stopPropagation();
	};

	return (
		<div className="c-dimmer" onClick={hideSportsCampDetail}>
			<div className="c-detail-fiche-wrap">
				<div className="c-detail-fiche sportcamp" onClick={stopPropagation}>
					{isLoadingMore ? (
						<LoadingMore />
					) : (
						<>
							<div className="c-detail-fiche__close-button" onClick={hideSportsCampDetail}>
								<i className="fa fa-close"></i>
							</div>
							{moreInfoCard.absoluteImageUrl !== null && (
								<div className="c-detail-fiche__img-banner">
									<Image
										src={moreInfoCard.absoluteImageUrl}
										alt={moreInfoCard.activityName}
									/>
								</div>
							)}
							<DetailHeader />
							<DetailBody />
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default SportsCampsDetail;
